import { Component, OnInit, ViewChild } from '@angular/core'
import { Router, ActivatedRoute, Params } from '@angular/router'
import { documentosSeparador } from '../documentos-separador/documentos-separador.component'
import { visorPdfComponent } from '../visorPdf/visorPdf.component'
import { FDLMService } from '../../services/FDLM.Service';//SE IMPORTA EL SERVICIO
import { AudioService } from '../../services/AudioService.service';
import { ValidaPerfil, DocumentoSol } from '../../Interfaces';
import { Observable } from 'rxjs';
import { importador } from '../importador/importador.component';
import { Usuario } from '../../models/usuario';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { cabezote } from '../cabezote/cabezote.component';
import { interval } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { DiagsoundComponent } from '../diagsound/diagsound.component'
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: "separador",
  templateUrl: "./separador.component.html"
})
export class separador implements OnInit {
  public appVersion = "1.0.5";
  public varNumSolicitud: string;
  public lstValidaPerfil: Observable<ValidaPerfil[]>;

  public varIdPerfil: number;
  public varEstPermiteConsDocVisor: number;
  public varEstPermiteDescargarDoc: number;
  public varEstPermiteImportarDoc: number;
  public varStrNombreExpediente: string;
  public varStrNombreUsuario: string;

  public selImportar: boolean = false;
  public selVisor: boolean = false;
  public selDocu: boolean = false;
  public verMsgPermiso: boolean = false;
  public selDocumento: DocumentoSol;

  public usuario: Usuario;
  public msgMensaje: string;
  public NoClick: boolean = true;

  public lstDocs: DocumentoSol[] = [];
  public idxDoc: number;

  @ViewChild(cabezote) cabezote: cabezote;
  @ViewChild(documentosSeparador) docSeparadorComponent: documentosSeparador;//PARA PODER LLAMAR METODOS DEL COMPONENTE
  @ViewChild(importador) importadorCtr: importador;//PARA PODER LLAMAR METODOS DEL COMPONENTE
  @ViewChild(visorPdfComponent) visorPdf: visorPdfComponent;

  constructor(private route: ActivatedRoute, private router: Router,
    private FDLMService: FDLMService,
    private AudioService: AudioService,
    private formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog) {
    this.FDLMService.usuario.subscribe(res => {
      this.usuario = res;
      
    });
  }

  public consSolForm = this.formBuilder.group({
    numSolicitud: ['', Validators.required]
  })

  public ngOnInit() {
    this.varNumSolicitud = "";
    this.route.params.forEach((params: Params) => {
      this.varNumSolicitud = params["vns"];
    });

    if (this.varNumSolicitud !== undefined) {
      //SE ENVIA A VALIDAR EL PERFIL
      this.ValidarPerfilAcceso("1");      
    }
  }

  public ValidarPerfilAcceso(parIdCreaSol) {
    //ENVIA A CONSULTAR QUE PERFIL TIENE RELACIONADO EL USUARIO AUTENTICADO

    if (this.varNumSolicitud !== undefined) {
      this.FDLMService.ValidaPerfilUsuAutenticaXNumSol(this.varNumSolicitud, parIdCreaSol).subscribe(
        rta => {
          if (rta.length > 0) {
            rta.forEach(itm => {
              this.varIdPerfil = itm.tmpIdPerfil;

              this.varEstPermiteConsDocVisor = itm.tmpEstPermiteConsDocVisor;
              this.varEstPermiteDescargarDoc = itm.tmpEstPermiteDescargarDoc;
              this.varEstPermiteImportarDoc = itm.tmpEstPermiteImportarDoc;
              this.varStrNombreExpediente = itm.strNombreExpediente;
              this.varStrNombreUsuario = itm.strNombreUsuario;

              if (this.varIdPerfil !== 0 && itm.tmpIdGpCabSepara !== 0) {
                this.verMsgPermiso = false;
                this.msgMensaje = "";
                this.cargaInfoSolicitud();

              }
              else {
                this.varIdPerfil = 0;
                if (itm.tmpIdGpCabSepara !== 0) {
                  this.msgMensaje = "El usuario " + this.varStrNombreUsuario + " no cuenta con permiso para consultar el expediente: " + this.varStrNombreExpediente + " y solicitud: " + this.varNumSolicitud + ", por favor contacte a su administrador.";
                }
                else {
                  this.msgMensaje = "No se encontro solicitud:" + this.varNumSolicitud;
                }

                this.selDocu = false;
                this.verMsgPermiso = true;
              }
            })
          }
          else {
            this.varEstPermiteConsDocVisor = 0;
            this.varEstPermiteDescargarDoc = 0;
            this.varEstPermiteImportarDoc = 0;
            this.varStrNombreExpediente = "";
            this.varStrNombreUsuario = "";
            this.varNumSolicitud = ""
            this.selDocu = false;
            this.verMsgPermiso = false;
            this.msgMensaje = "";
          }
          this.NoClick = true;
          this.spinner.hide();
          //console.log('Finaliza Consulta');
        });
    }
    else {
      this.varEstPermiteConsDocVisor = 0;
      this.varEstPermiteDescargarDoc = 0;
      this.varEstPermiteImportarDoc = 0;
      this.selDocu = false;
      this.NoClick = true;
      this.spinner.hide();
    }
  }

  public subirArchivo() {
    //ESTABLECE LA CONFIGURACION DE ACCION CARPETA POR ESTADO CREDITO
    this.selDocu = false;
    this.selImportar = true;
    this.selVisor = false;
  }

  public cancelarImportar() {
    this.selDocu = true;
    this.selImportar = false;
    this.selVisor = false;
    this.CargaArchivos();
  }

  public finalizarImportar() {
    this.selDocu = true;
    this.selImportar = false;
    this.selVisor = false;
    this.CargaArchivos();
  }

  public MostrarVisor(parselDocumento: DocumentoSol) {
    this.docSeparadorComponent.lstDocumentos.subscribe(result => this.lstDocs = result);
    this.selDocu = false;
    this.selImportar = false;

    this.selDocumento = parselDocumento;
    if (!this.selVisor) {
      this.selVisor = true;
    }
    else {
      this.visorPdf.cargaInfoVisor(this.selDocumento);
    }
  }

  public VisPreSonido(parVisPreSonido: DocumentoSol) {
    const dialogRef = this.dialog.open(DiagsoundComponent, { data: parVisPreSonido })

    dialogRef.afterClosed().subscribe(result => {
      this.AudioService.stop();

      //this.email = result;
    });
  }



  public CerrarVisor() {
    this.selDocu = true;
    this.selImportar = false;
    this.selVisor = false;
    //this.ValidarPerfilAcceso();
  }

  public consSolicitudClick(event: any) {
    //console.log('Consultando');
    this.spinner.show();
    this.NoClick = false;

    try {
      this.consSolicitud();
    }
    catch (error) {
      //Swal.fire({ text: error.message, icon: 'warning', confirmButtonText: "Aceptar" });
      event.target.disabled = false;
      this.NoClick = true;
      this.spinner.hide();
      console.log('Error:' + error);
    }
  }

  public consSolicitud() {
    this.spinner.show();
    if (this.consSolForm.valid) {
      this.varNumSolicitud = this.consSolForm.value.numSolicitud;
      this.ValidarPerfilAcceso("0");
    }
    else {
      this.varNumSolicitud = "";
      this.NoClick = true;
      this.spinner.hide();
    }
  }

  public cargaInfoSolicitud() {
    if (this.varIdPerfil !== 0) {
      if (this.cabezote !== undefined) {
        this.cabezote.varNumSolicitud = this.varNumSolicitud;
        this.cabezote.CargarInfoCabezote();
      }
      this.CargaArchivos();
    }
    this.selImportar = false;
    this.selVisor = false;
  }

  public CargaArchivos() {
    if (this.selDocu === true) {
      //this.docSeparadorComponent !== undefined
      if (this.docSeparadorComponent !== undefined) {
        this.docSeparadorComponent.varNumSolicitud = this.varNumSolicitud;
        this.docSeparadorComponent.varIdPerfil = this.varIdPerfil;
        this.docSeparadorComponent.cargaInfoSolicitud();
      }
    }
    else {
      this.selDocu = true;
    }
  }

  public AntDoc() {
    this.idxDoc = this.lstDocs.map(function (x) { return x.tmpIdCabVer }).indexOf(this.selDocumento.tmpIdCabVer);

    if (this.idxDoc > 0) {
      this.idxDoc -= 1;
    }
    else {
      this.idxDoc = this.lstDocs.length - 1;
    }

    this.selDocumento = this.lstDocs[this.idxDoc];
    this.visorPdf.cargaInfoVisor(this.selDocumento);
  }

  public SigDoc() {
    this.idxDoc = this.lstDocs.map(function (x) { return x.tmpIdCabVer }).indexOf(this.selDocumento.tmpIdCabVer);

    if (this.idxDoc < this.lstDocs.length-1) {
      this.idxDoc += 1;
    }
    else {
      this.idxDoc = 0;
    }
   
    this.selDocumento = this.lstDocs[this.idxDoc];
    this.visorPdf.cargaInfoVisor(this.selDocumento);
    //this.docSeparadorComponent.lstDocumentos;
  }

  logout() {
    this.FDLMService.logout();
    this.router.navigate(['/login']);
  }


}
